import DealerListIcon from "../assets/icons/sidebar/DealerListIcon";
import OverviewIcon from "../assets/icons/sidebar/OverviewIcon";
import ReconcileIcon from "../assets/icons/sidebar/ReconcileIcon";
import StatementIcon from "../assets/icons/sidebar/StatementIcon";
import TraderListIcon from "../assets/icons/sidebar/TraderListIcon";
import { Role } from "../types/common.type";

interface IMenu {
  name: string;
  path: string;
  icon?: () => JSX.Element;
  role: Role[];
}

interface IAllSidebarMenu extends IMenu {
  children?: IMenu[];
}

const AllSidebarMenu: IAllSidebarMenu[] = [
  {
    name: "Dashboard",
    path: "/admin/dashboard",
    icon: OverviewIcon,
    role: ["admin"],
  },
  {
    name: "Statement",
    path: "/admin/statement",
    icon: StatementIcon,
    role: ["admin"],
  },
  {
    name: "Dealer List",
    path: "/admin/dealer-list",
    icon: DealerListIcon,
    role: ["admin"],
  },
  {
    name: "Trader List",
    path: "/admin/trader-list",
    icon: TraderListIcon,
    role: ["admin"],
  },
  {
    name: "Reconcile",
    path: "/admin/reconcile",
    icon: ReconcileIcon,
    role: ["admin"],
  },
];

export default AllSidebarMenu;
